import { useQuery } from '@tanstack/react-query';

import { venueGetUnreadNotificationCountApi } from '../../../api/notifications/venueGetUnreadNotificationCountApi';

const POLLING_INTERVAL_MS = 60_000;

export const useVenueGetUnreadNotificationCountQuery = (venueID: string | undefined) => {
  const { data, isFetching, isLoading, refetch } = useQuery({
    queryKey: ['venueGetUnreadNotificationCount', venueID],
    queryFn: () => venueGetUnreadNotificationCountApi(venueID!),
    enabled: !!venueID,
    refetchOnWindowFocus: true,
    refetchInterval: () => (document.visibilityState === 'visible' ? POLLING_INTERVAL_MS : false),
    refetchIntervalInBackground: false,
  });

  return { count: data ?? 0, isFetching, isLoading, refetch };
};
